<template>
  <Loader v-if="loader" />

  <div class="card p-3">
    <div class="grid">
      <div class="col-12 lg:col-3">
        <Dropdown v-model="selectedTypeFornitura" :options="typesFornitura" optionLabel="name" optionValue="name"
          placeholder="Seleziona tipo fornitura" class="inputfield w-full" />
        <div v-show="validationErrors.fornitura && submitted" class="p-error">Seleziona campo.</div>
      </div>
      <div class="col-12 lg:col-3">
        <Dropdown v-model="selectedTypePratica" :options="typesPratica" optionLabel="name" optionValue="name"
          placeholder="Seleziona tipo pratica" class="inputfield w-full" />
        <div v-show="validationErrors.pratica && submitted" class="p-error">Seleziona campo.</div>
      </div>
      <div class="col-12 lg:col-3">
        <Calendar class="w-full" v-model="period" dateFormat="dd-mm-yy" :showIcon="true" selectionMode="range"
          placeholder="Periodo invio" />
      </div>
      <div class="col-12 lg:col-3">
        <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" class="w-full" />
      </div>
    </div>
  </div>


  <div class="mt-3 sosp-riatt-pratiche">
    <div class="grid" v-if="Object.keys(originalItems).length > 0">
      <div class="col-6">
        <InputText @keyup="onGlobalSearch" class="mt-4 mb-2 " v-model="searchString" type="text"
          placeholder="Cerca ..." />
      </div>
      <div class="col-6 flex justify-content-end align-items-end">
        <Button label="Esporta" icon="pi pi-download" class="p-button-secondary" @click="downloadFile($event)" />
      </div>
    </div>


    <Accordion :multiple="true" lazy>
      <AccordionTab v-for="(elements, fornitura) in items" :key="fornitura">
        <template #header>
          <div class="grid grid-nogutter w-full">
            <div class="col-8">
              <p v-if="elements[0].pod_id == 0">
                {{ elements[0].pod }}
              </p>
              <p v-else>
                <router-link :to="`/ask/pods/${elements[0].pod_id}/dettagli`" target="_blank">
                  {{ elements[0].pod }}
                </router-link>
              </p>
            </div>
            <small class="col-4 text-500 flex justify-content-end">{{ items[fornitura].length }} {{ items[fornitura].length
              > 1 ? 'pratiche' : 'pratica'}}</small>
            <div class="col-12 text-500 text-xs">
              <div class="grid grid-nogutter mt-2">
                <div class="col p-1">Cliente: <b>{{ items[fornitura][0].cliente }}</b></div>
                <div class="col p-1">Rappresentante: <b>{{ items[fornitura][0].rappresentante }}</b></div>
                <div class="col p-1">Code Provider: <b>{{ items[fornitura][0].cod_pratica_provider }}</b></div>
                <div class="col p-1">Pratica: <b>{{ items[fornitura][0].type }}</b></div>
                <div class="col p-1">Esito: <b>{{ items[fornitura][0].esito_pratica }}</b></div>
                <div class="col p-1">Data Pratica: <b>{{ formatDate(items[fornitura][0].data_pratica) }}</b></div>
                <div class="col p-1">Data Esito: <b>{{ formatDate(items[fornitura][0].data_esito) }}</b></div>
                <div class="col p-1">Agente: <b>{{ items[fornitura][0].agente }}</b></div>
              </div>
            </div>
          </div>
        </template>


        <DataTable :value="elements" :paginator="true" :rows="10" :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="pod" header="Pod" :sortable="true"></Column>
          <Column field="cliente" header="Cliente" :sortable="true"></Column>
          <Column field="piva" header="P.iva" :sortable="true"></Column>
          <Column field="codfis" header="C.fiscale" :sortable="true"></Column>
          <Column field="cod_servizio" header="Code" :sortable="true"></Column>
          <Column field="type" header="Tipo" :sortable="true"></Column>
          <Column field="provider" header="Provider" :sortable="true" class="provider"></Column>
          <Column field="cod_pratica" header="Codice pratica interno"></Column>
          <Column field="cod_pratica_provider" header="Codice pratica provider"></Column>
          <Column field="costo_imponibile" header="Imponibile" :sortable="true"></Column>
          <Column field="costo_iva" header="Iva" :sortable="true"></Column>
          <Column field="costo_totale" header="Totale" :sortable="true"></Column>
          <Column field="data_pratica" header="Data Pratica" :sortable="true">
            <template #body="{ data }">
              {{ formatDate(data.data_pratica) }}
            </template>
          </Column>
          <Column field="data_esito" header="Data Esito" :sortable="true">
            <template #body="{ data }">
              {{ formatDate(data.data_esito) }}
            </template>
          </Column>
          <Column field="data_decorrenza" header="Data Decorrenza" :sortable="true">
            <template #body="{ data }">
              {{ formatDate(data.data_decorrenza) }}
            </template>
          </Column>
          <Column field="esito_pratica" header="Esito" :sortable="true"></Column>
          <Column field="motivazione_esito" header="Motivazione Esito" :sortable="true"></Column>
          <Column field="agente" header="Agente" :sortable="true"></Column>
        </DataTable>
      </AccordionTab>
    </Accordion>

  </div>

</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
// import ServiceOperation from '@/services/ask-operation/operation-service'
import { getCurrentInstance, ref } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'

export default {
  components: {
    Loader
  },
  setup() {

    const dt = ref();
    const loader = ref(false);
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    // const serviceOperation = new ServiceOperation(self.$http, self.$eventBus)
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const validationErrors = ref({})
    const submitted = ref(false)
    const searchString = ref('')
    const items = ref([])
    const originalItems = ref([])
    const selectedItems = ref([])
    const selectedTypeFornitura = ref()
    const typesFornitura = ref([
      { name: 'TUTTI' },
      { name: 'POD' },
      { name: 'PDR' },
    ])
    const selectedTypePratica = ref()
    const typesPratica = ref([
      { name: 'TUTTI' },
      { name: 'sospensioni' },
      { name: 'riattivazioni' },
    ])
    const period = ref(null)


    const searchData = () => {
      submitted.value = true
      if (validateForm()) {
        loader.value = true
        let dateFrom = null;
        let dateTo = null
        if (period.value) {
          dateFrom = moment(period.value[0]).format('YYYY-MM-DD');
          dateTo = period.value[1] != null ? moment(period.value[1]).format('YYYY-MM-DD') : dateFrom
        }

        service.getSospensioniRiattivazioniForniture(selectedTypeFornitura.value, selectedTypePratica.value, dateFrom, dateTo)
          .then((res) => {
            items.value = res.items
            originalItems.value = res.items
          }).finally(() => {
            loader.value = false
          })
      }
    }

    const onGlobalSearch = () => {

      items.value = { ...originalItems.value }

      if (searchString.value.length > 0) {

        for (const [fornitura, els] of Object.entries(originalItems.value)) {
          let obj;
          obj = els.filter((el) => {
            if (
              el.pod.toLowerCase().includes(searchString.value.toLowerCase())
              || el.cod_pratica_provider != null && el.cod_pratica_provider.toLowerCase().includes(searchString.value.toLowerCase())
              || el.rappresentante != null && el.rappresentante.toLowerCase().includes(searchString.value.toLowerCase())
              || el.cliente != null && el.cliente.toLowerCase().includes(searchString.value.toLowerCase())
              // || el.esito_pratica != null && el.esito_pratica.toLowerCase().includes(searchString.value.toLowerCase())
              // || el.data_pratica.includes(searchString.value)
              // || el.data_esito.includes(searchString.value)
            ) {
              return el
            }
          })
          if (obj.length == 0) {
            delete items.value[fornitura]
          }
        }
      }
    }

    const downloadFile = () => {
      loader.value = false
      service.downloadFileSospRiattPratiche(items.value)
        .finally(() => {
          loader.value = false
        })
    };


    const validateForm = () => {
      if (selectedTypeFornitura.value == null)
        validationErrors.value['fornitura'] = true;
      else
        delete validationErrors.value['fornitura'];

      if (selectedTypePratica.value == null)
        validationErrors.value['pratica'] = true;
      else
        delete validationErrors.value['pratica'];

      return !Object.keys(validationErrors.value).length;
    }


    return {
      dt,
      loader,
      filters,
      searchString,
      validationErrors,
      submitted,
      typesFornitura,
      selectedTypeFornitura,
      typesPratica,
      selectedTypePratica,
      searchData,
      items,
      originalItems,
      selectedItems,
      period,
      downloadFile,
      formatDate,
      onGlobalSearch
    }
  }
}
</script>

<style>
.sosp-riatt-pratiche .p-accordion-tab {
  margin-bottom: 10px;
}
</style>
